<nav class="navbar navbar-light bg-light p-10">
    <h1>Travel Agency</h1>
</nav>
<div class="container pt-5">
    <div id="currencies">
        <div *ngIf="!isLoading">
            <!--        <currency-format *ngFor="let currency of currencies" [currency]="currency"> </currency-format>-->
            <div class="row ">
                <div class="col-10 text-center">
                    <h1>
                        Currency Management
                    </h1>
                </div>
                <div class="col-2">
                    <button class="btn btn-block btn-primary"
                            (click)="openDialogEditCreate()">
                        <i class="fas fa-plus fa-2x"></i>
                        <span>
                            Add Currency
                        </span>
                    </button>
                </div>
                <table  *ngIf="currencies.length > 0 " class="table table-striped mt-5 table-bordered">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">
                            <div class="currency">
                                <h4>
                                    Country Code
                                </h4>
                            </div>
                        </th>
                        <th scope="col">
                            <div class="currency">
                                <h4>
                                    Currency Code
                                </h4>
                            </div>
                        </th>
                        <th scope="col">
                            <div class="currency">
                                <h4>
                                   Format
                                </h4>
                            </div>
                        </th>
                        <th scope="col">
                            <div class="currency">
                                <h4>
                                    Creation Date
                                </h4>
                            </div>
                        </th>
                        <th scope="col">
                            <div class="currency">
                                <h4>
                                    Actions
                                </h4>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of currencies">
                        <td>
                            <div class="currency">
                                <h3>{{data.countryCode}}</h3>
                            </div>
                        </td>
                        <td>
                            <div class="currency">
                                <h3>
                                    {{data.currencyCode}}
                                </h3>
                            </div>
                            </td>
                        <td> <currency-format [currency]="data"> </currency-format></td>
                        <td>
                            <div class="div currency">
                                <h3>
                                    {{data.createdAt | date:'mediumDate' }}
                                </h3>
                            </div>
                        </td>
                        <td>
                            <div class="div currency">
                                <button (click)="openDialogEditCreate(data)"  class="fas fa-edit fa-2x text-success p-2"></button>
                                <button (click)="deleteCurrency(data)" class="fas fa-trash text-danger p-2 fa-2x"></button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h5 *ngIf="currencies.length == 0" style="text-align: start; margin-top: 10px;" >There are no currencies to display</h5>
            </div>
        </div>
    </div>
</div>
